import { useQuery } from '@tanstack/react-query'
import qs from 'querystring'
import httpClient from '~/modules/core/httpClient'
import { MOCK_NAVIGATION_DATA } from './constant'
import {
  set as setLocalStorage,
  get as getLocalStorage,
} from '~/utils/storage/localStorage'
import { queryFnWrapper } from '~/utils/utility'
import csClient from '~/modules/core/csClient'
import { FLAGS } from '~/constants/flags'
import { useFeatureIsOn } from '@growthbook/growthbook-react'

const getNavigationList = ({
  storeId = '',
  isEnableCSTicket = false,
  isEnableCSCouponLimit = false,
  isEnableCSNewPromotion = false,
  isEnableEmailMarketing = false,
  isEnableDynamicCanadaPostServiceOption = false,
  isDisableFulfillmentModule = false,
}) => {
  const params = {
    bs_store_id: storeId,
    flag_profile_3_new_setting: true,
    flag_new_locations: true,
    ...(isEnableCSTicket && { flag_ticket: true }),
    ...(isEnableCSCouponLimit && { cs_8063_coupon_limit: true }),
    ...(isEnableCSNewPromotion && { cs_8181_new_promotion_module: true }),
    ...(isEnableEmailMarketing && { cs_8598_email_marketing: true }),
    ...(isEnableDynamicCanadaPostServiceOption && {
      bs_13857_dynamic_canada_post_service_option: true,
    }),
    ...(isDisableFulfillmentModule && {
      bs_14785_disable_fulfillment_module: true,
    }),
  }

  return httpClient.json.get(
    `/unification/bs_navigation?${qs.stringify(params)}`,
  )
}

const getCachedNav = () =>
  getLocalStorage('cached_nav_bar') || MOCK_NAVIGATION_DATA

const setCachedNav = (data) => {
  setLocalStorage('cached_nav_bar', data)
}

export const useNavigationConfig = (storeId, enabled = true) => {
  const placeholderData = getCachedNav()
  const isEnableCSTicket = useFeatureIsOn(FLAGS.CS_8101)
  const isEnableCSCouponLimit = useFeatureIsOn(FLAGS.CS_8063)
  const isEnableCSNewPromotion = useFeatureIsOn(FLAGS.CS_8181)
  const isEnableEmailMarketing = useFeatureIsOn(FLAGS.CS_8598_EMAIL_MARKETING)
  const isEnableDynamicCanadaPostServiceOption = useFeatureIsOn(FLAGS.BS_13857)
  const isDisableFulfillmentModule = useFeatureIsOn(FLAGS.ACD_14785)

  return useQuery({
    queryKey: [
      'getNavigationList',
      storeId,
      isEnableCSTicket,
      isEnableCSCouponLimit,
      isEnableCSNewPromotion,
      isEnableEmailMarketing,
      isEnableDynamicCanadaPostServiceOption,
      isDisableFulfillmentModule,
    ],
    queryFn: queryFnWrapper({
      queryFn: () =>
        getNavigationList({
          storeId,
          isEnableCSTicket,
          isEnableCSCouponLimit,
          isEnableCSNewPromotion,
          isEnableEmailMarketing,
          isEnableDynamicCanadaPostServiceOption,
          isDisableFulfillmentModule,
        }),
      onError: (e) => {
        // biome-ignore lint/suspicious/noConsole: reason
        console.error(e)
      },
    }),
    placeholderData,
    enabled,
    select: (data) => {
      if (!data) return {}
      setCachedNav(data)
      return data
    },
    retry: 10,
  })
}

const getPlanTier = () => csClient.json.get('payments/get-plan-tier')

export const useGetPlanTier = ({ enabled = true }) =>
  useQuery({
    queryKey: ['getPlanTier'],
    queryFn: () => getPlanTier(),
    initialData: null,
    enabled,
    select: (res) => res?.data || {},
  })
